(() => {
  if (window.dsJournalInitialized) return;
  window.dsJournalInitialized = true;
  const enhance = (root = document) => {
    root.querySelectorAll('[data-ds-article]').forEach((article) => {
      if (article.dataset.enhanced) return;
      article.dataset.enhanced = 'true';
      const content = article.querySelector('[data-article-content]');
      if (!content) return;
      const intro = content.firstElementChild;
      if (intro?.tagName === 'P' && !intro.querySelector('img, iframe, video') && intro.textContent.trim() && intro.textContent.trim().length < 350) {
        intro.classList.add('ds-story__intro');
        const existingIntro = article.querySelector('.ds-story__header .ds-story__intro');
        if (existingIntro) existingIntro.replaceWith(intro);
        else article.querySelector('.ds-story__header h1').after(intro);
      }
      const children = Array.from(content.children);
      children.filter((node) => node.tagName === 'P' && /^Tipp\s*:/i.test(node.textContent.trim())).forEach((node) => node.classList.add('ds-story__tip'));
      const heading = (node, pattern) => /^(P|H[2-4]|DIV)$/.test(node.tagName) && pattern.test(node.textContent.trim());
      const ingredients = children.find((node) => heading(node, /^Zutaten\s*:?$/i));
      const method = children.find((node) => heading(node, /^Zubereitung\s*:?$/i));
      if (!ingredients || !method) return;
      const ingredientList = ingredients.nextElementSibling;
      const methodList = method.nextElementSibling;
      if (ingredientList?.tagName !== 'UL' || methodList?.tagName !== 'OL' || ingredientList.nextElementSibling !== method) return;
      const recipe = document.createElement('section');
      recipe.className = 'ds-recipe';
      recipe.id = content.dataset.recipeId;
      recipe.tabIndex = -1;
      recipe.setAttribute('aria-labelledby', `${recipe.id}-heading`);
      const left = document.createElement('div');
      left.className = 'ds-recipe__ingredients';
      const right = document.createElement('div');
      right.className = 'ds-recipe__method';
      const ingredientHeading = document.createElement('h2');
      ingredientHeading.textContent = ingredients.textContent.trim().replace(/:$/, '');
      ingredientHeading.id = `${recipe.id}-heading`;
      const methodHeading = document.createElement('h2');
      methodHeading.textContent = method.textContent.trim().replace(/:$/, '');
      ingredients.before(recipe);
      left.append(ingredientHeading, ingredientList);
      right.append(methodHeading, methodList);
      recipe.append(left, right);
      ingredients.remove();
      method.remove();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
